<script lang="ts" setup>
import {
  rankStaticPath,
  useRankHalfText,
  useRankMoment,
} from "@/composable/rank";
import { computed } from "vue";
import moment from "moment-timezone";
import { shouldHideHalfText } from "@/stores/coinRank";

const props = defineProps<{
  dtStart: string;
}>();

export interface RankBannerInstance {
  refreshRank: () => Promise<void>;
}

const mothIconConfig = [
  "January.svg",
  "February.svg",
  "March.svg",
  "April.svg",
  "May.svg",
  "June.svg",
  "July.svg",
  "August.svg",
  "September.svg",
  "October.svg",
  "November.svg",
  "December.svg",
];
const getMonthIcon = (dtStart: string) => {
  const month = useRankMoment(dtStart).month();
  return `${rankStaticPath}/month/${mothIconConfig[month]}`;
};
const monthIcon = getMonthIcon(props.dtStart);
const hideHalfText = computed(() => shouldHideHalfText(props.dtStart));
</script>
<template>
  <div
    class="bg-primary flex flex-col justify-between gap-6 p-4 text-primary-content"
  >
    <div
      class="flex flex-col justify-center items-center flex-1 gap-2 pointer-events-none"
    >
      <div class="flex items-center justify-center gap-2">
        <img
          :src="monthIcon"
          alt="logo"
          class="w-20 md:w-32"
          crossorigin="anonymous"
        />
        <span v-if="!hideHalfText" class="text-base">
          ({{ useRankHalfText(dtStart) }})
        </span>
      </div>
      <span class="text-xl md:text-2xl font-bold">{{
        $t("rank.mostPopularRank")
      }}</span>
      <LogoIcon class="w-20 text-white" />
    </div>
  </div>
</template>
